/*------------------------------------------------------------------
Document Setup
------------------------------------------------------------------*/
var html = document.querySelector('html'); // attach a throttled scroll event to the window

Meteora.attach(window, 'scroll', function () {
  // Here we toggle the class fixed-header on the html to change out header styles as we scroll
  if (window.pageYOffset >= 1 & !html.classList.contains('fixed-header')) {
    html.classList.add('fixed-header');
  } else if (window.pageYOffset < 1 && html.classList.contains('fixed-header')) {
    html.classList.remove('fixed-header');
  }
}, 100);

(function () {
  var notification = document.querySelector('.js-notification') || false; // Find the close button

  var close = document.querySelector('.js-notification__close') || false; // Check to see if the notification exists

  if (!notification) return; // If the window session storage has a value of true for the notification, hide it

  if (window.sessionStorage.getItem('hide-notification') === 'true') return; // Otherwise, show the notification

  document.body.classList.add('show-notification-banner'); // if there is a close button

  if (!close) return;
  console.log(close); // When we click the close button, hide the notification and set the session storage value to true

  close.addEventListener('click', function () {
    document.body.classList.remove('show-notification-banner');
    window.sessionStorage.setItem('hide-notification', 'true');
    window.equalizers['header'].update();
  });
})();